var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","stroke":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.59203 0.75415L10.417 1.57911L4.99614 6.99996L10.417 12.4208L9.59203 13.2458L3.34622 6.99996L9.59203 0.75415Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }